"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkPaymentRequest = exports.userLogout = exports.userLoad = exports.cardsRemove = exports.cardsLoad = exports.ordersLoad = exports.postPushToken = exports.postOrder = exports.fetchRcmData = exports.loadRestaurantMenu = exports.loadRestaurant = exports.loadChain = void 0;
var axios_1 = __importStar(require("../utils/axios"));
var loadChain = function (chainId) {
    return (0, axios_1.get)("/api/chains/".concat(chainId)).then(function (res) { return res.data; });
};
exports.loadChain = loadChain;
var loadRestaurant = function (restaurantId) {
    return (0, axios_1.get)("/api/restaurant/".concat(restaurantId)).then(function (res) { return res.data; });
};
exports.loadRestaurant = loadRestaurant;
var loadRestaurantMenu = function (restaurantId, type) {
    return (0, axios_1.get)("/api/restaurant/".concat(restaurantId, "/menu?type=").concat(type)).then(function (res) { return res.data; });
};
exports.loadRestaurantMenu = loadRestaurantMenu;
var fetchRcmData = function (restaurantId) {
    return (0, axios_1.get)("/api/rcm/".concat(restaurantId)).then(function (res) { return res.data; });
};
exports.fetchRcmData = fetchRcmData;
var postOrder = function (data) {
    return (0, axios_1.post)("/api/order", data).then(function (res) { return res.data; });
};
exports.postOrder = postOrder;
var postPushToken = function (data) {
    return (0, axios_1.post)("/api/push", data).then(function (res) { return res.data; });
};
exports.postPushToken = postPushToken;
var ordersLoad = function () {
    return (0, axios_1.get)("/api/order").then(function (res) { return res.data; });
};
exports.ordersLoad = ordersLoad;
var cardsLoad = function () {
    return (0, axios_1.get)("/api/stripe/card").then(function (res) { return res.data; });
};
exports.cardsLoad = cardsLoad;
var cardsRemove = function (card) {
    return axios_1.default.delete("/api/stripe/card", {
        params: { 'card': card }
    }).then(function (res) { return res.data; });
};
exports.cardsRemove = cardsRemove;
var userLoad = function () {
    return (0, axios_1.get)('/api/user');
};
exports.userLoad = userLoad;
var userLogout = function () {
    return (0, axios_1.get)('/api/logout');
};
exports.userLogout = userLogout;
var checkPaymentRequest = function (data) {
    return (0, axios_1.post)("/api/payment/check", data).then(function (res) { return res.data; });
};
exports.checkPaymentRequest = checkPaymentRequest;
